import PropTypes from 'prop-types';
import React from 'react';
import BrIcons from '@components/BrIcons';
import './index.scss';

export default function DiagnosticsFooter(props) {
  const { type } = props;

  let displayElement;
  switch (type) {
    case 'Boosted':
      displayElement = (
        <span className="br-pc-v1-boosted">
          <BrIcons.Boost disableHover colored />
          <span className="operation-name">Boosted</span>
        </span>
      );
      break;
    case 'Buried':
      displayElement = (
        <span className="br-pc-v1-buried">
          <BrIcons.Bury disableHover colored />
          <span className="operation-name">Buried</span>
        </span>
      );
      break;
    case 'Locked':
      displayElement = (
        <span className="br-pc-v1-seq-locked">
          <BrIcons.OrangeLock disableHover colored />
          <span className="operation-name">Sequentially Locked</span>
        </span>
      );
      break;
    default: break;
  }

  return (
    <div className="br-pc-v1-diagnostics-footer">
      {displayElement}
      {props.children}
    </div>
  );
}

/**
 * @param {Array[ReactNode]|ReactNode} children any extra content to be displayed in footer section
 * @param {'Boosted'|'Buried'} type type of footer
 */
DiagnosticsFooter.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  type: PropTypes.oneOf(['Boosted', 'Buried']).isRequired,
};
